import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import Stat from "../../../components/shared/stat";
import { Card, CardContent, CardHeader } from "@mui/material";

const SettingEnergyPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="navy"
          value={23}
          unit="عدد"
          label="شهرستان"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="info"
          value={85}
          unit="عدد"
          label="ایستگاه"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="success"
          value={12}
          unit="عدد"
          label="فیدر بیرونی"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="primary"
          value={20}
          unit="عدد"
          label="نقطه تبادل انرژی"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader title="ادامه" />
          <CardContent>content</CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SettingEnergyPage;
